import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { NewButton } from '../NewButton';
import styles from "./PartnerCards.module.css";
import data from "../../data/sponsors.json";


// for the carousel

import { tracking } from "../../../../utils/tracking";

export const PartnerCards = () => {

   return (
      <>
         <header className={styles.header}>
            <p style={{ maxWidth: '800px' }}>
               “One of the top events of the year for the invaluable content, presentation quality and opportunities to connect investors and founders.”
            </p>
            <p>
               - Tina Gregory, Early Growth
            </p>
         </header>
         <main >
            <div className={styles.partners}>
               {
                  data.map(i => i.values).flat().map((partner, partnerIdx) => {
                     console.log(partner)
                     if (partner.sponsor_type === 'industry_partners') return <div key={partnerIdx}></div>
                     let numOfmembers = JSON.parse(partner?.team_members || "[]").length
                     return (
                        <div
                           onClick={() => tracking(292, partner.id)}
                           className={styles.partner}
                           key={partner.id}>
                           <section className={styles.details}>
                              <h5>{partner.display_name} Partner</h5>
                              <section>
                                 <img src={partner.logo_url} alt='partner-logo' />
                              </section>
                              <p>{partner.description}</p>

                           </section>

                           <section className={styles.members}
                              style={{
                                 flexBasis: numOfmembers >= 2 && '70%',
                                 flexWrap: numOfmembers === 3 && 'wrap',
                              }}>
                              {
                                 JSON.parse(partner.team_members || "[]").map((member, memberIdx) =>
                                    <article className={styles.member} key={member.id}>
                                       <img src={member.headshot_url} alt="team-member" />
                                       <h6>{member.firstname} {member.lastname}</h6>
                                       <p>{member.jobtitle}</p>
                                       <div>
                                          <a href={member.linkedin} target='_blank' rel='noreferrer'><LinkedInIcon /></a>
                                       </div>
                                    </article>
                                 )
                              }
                           </section>
                           <a href={partner.website} target="_blank" rel='noreferrer'>
                              <NewButton color='white' bgColor='#CF1B5B' name='LEARN MORE' />
                           </a>
                        </div>
                     )
                  }
                  )
               }
            </div>
         </main>
      </>
   );
};
